import { gql } from '@/lib/graphql/gql'

export const USER_COMPANIES_QUERY = gql`
  query UserCompanies($idCompany: String) {
    user {
      id
      fullName
      email
      image
      createdAt
      sevallaIntercomJwt(idCompany: $idCompany)
      # NOTE: used to query if user is superadmin before RBAC provider is ready
      rolesInCompany(idCompany: "")
      companies @live {
        id
        createdAt
        name
        projects @live {
          id
          items {
            id
            name
            displayName
          }
        }
      }
    }
  }
`

export const USER_PERMISSIONS_QUERY = gql`
  query UserPermissions($idCompany: String!) {
    user {
      id
      rolesInCompany(idCompany: $idCompany) @live
      permissions @live {
        id
        type
        key
        idCompany
        idProject
        idApp
        idDatabase
        idStaticSite
        idObjectStorage
        idLoadBalancer
      }
    }
  }
`

export const TOTAL_SERVICES_QUERY = gql`
  query TotalServices($idCompany: String!) {
    company(id: $idCompany) {
      id
      apps @live {
        id
        total
      }
      pipelines @live {
        id
        total
      }
      databases @live {
        id
        total
      }
      staticSites @live {
        id
        total
      }
      objectStorages @live {
        id
        total
      }
      edgeLoadBalancers @live {
        id
        total
      }
      projects @live {
        id
        total
      }
    }
  }
`

export const COMPANY_SUSPENSION_QUERY = gql`
  query CompanySuspension($idCompany: String!) {
    company(id: $idCompany) {
      id
      sevallaBilling @live {
        id
        isSuspended
        suspensionReason
      }
    }
  }
`

export const COMPANY_BILLING_QUERY = gql`
  query CompanyBilling($idCompany: String!) {
    company(id: $idCompany) @live {
      id
      sevallaBilling {
        id
        creditUsage {
          id
          remainingCredits
        }
        hasValidBillingAddress
      }
      defaultPaymentMethod {
        id
        expYear
        expMonth
      }
    }
  }
`

export const SAML_INTERSTITIAL_QUERY = gql`
  query SamlInterstitial {
    user {
      id
      saml {
        id
        samlInterstitialData {
          id
          companyName
        }
      }
    }
  }
`
